module.exports = __webpack_public_path__ + "static/media/docsthumb.b721763c.png";